'use es6';
/*
 * Overrides the default Tab key handler with one that inserts soft tabs
 * instead of tab characters. The (built-in) `tabSize` prop controls how many
 * spaces are inserted.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import getComponentName from 'react-utils/getComponentName';
const SOFT_TABS_KEY_MAP = Object.freeze({
  Tab: cm => {
    if (cm.somethingSelected()) {
      cm.indentSelection('add');
      return;
    }

    cm.execCommand('insertSoftTab');
  }
});
export default function softTabs() {
  return function withSoftTabs(CodemirrorComponent) {
    /**
     * @class
     */
    class WithSoftTabs extends Component {
      constructor(props) {
        super(props);
        /** @type {Object} CodeMirror instance taken from ref */

        this.codemirror = null;
        this.refCodemirror = this.refCodemirror.bind(this);
      }

      componentDidUpdate(prevProps) {
        if (prevProps.disableSoftTabs !== this.props.disableSoftTabs) {
          if (this.props.disableSoftTabs) {
            this.removeKeyMap();
          } else {
            this.addKeyMap();
          }
        }
      }

      componentWillUnmount() {
        this.codemirror = null;
      }

      codemirrorDidMountOrUpdate(codemirror) {
        if (this.codemirror === codemirror) {
          return;
        }

        this.codemirror = codemirror;

        if (!this.codemirror) {
          return;
        }

        if (!this.props.disableSoftTabs) {
          this.addKeyMap();
        }
      }

      addKeyMap() {
        if (!this.codemirror) {
          return;
        }

        this.codemirror.addKeyMap(SOFT_TABS_KEY_MAP);
      }

      removeKeyMap() {
        if (!this.codemirror) {
          return;
        }

        this.codemirror.removeKeyMap(SOFT_TABS_KEY_MAP);
      }

      refCodemirror(ref) {
        const codemirror = ref && ref.codemirror;
        this.codemirrorDidMountOrUpdate(codemirror);

        if (this.props.refCodemirror) {
          this.props.refCodemirror(ref);
        }
      }

      render() {
        return /*#__PURE__*/_jsx(CodemirrorComponent, Object.assign({}, this.props, {
          refCodemirror: this.refCodemirror
        }));
      }

    }
    /*
     * Statics
     */


    WithSoftTabs.propTypes = {
      refCodemirror: PropTypes.func,
      disableSoftTabs: PropTypes.bool
    };
    WithSoftTabs.defaultProps = {
      disableSoftTabs: false
    };
    WithSoftTabs.displayName = `WithSoftTabs(${getComponentName(CodemirrorComponent, 'CodemirrorComponent')})`;
    return WithSoftTabs;
  };
}